// The splash screen is static markup in index.html, so it shows from the first paint and keeps animating
// while the bundle loads and React mounts. Its .is-hidden class finishes the progress bar and fades it out.
const SHOW_TRANSITION_MS = 400;
const HIDE_TRANSITION_MS = 700;

let hideTimeout: number | undefined;

// With a delay, the hide waits; showing the splash screen again before then cancels it.
export function hideSplashScreen(delayMs = 0): void {
  if (delayMs > 0) {
    window.clearTimeout(hideTimeout);
    hideTimeout = window.setTimeout(() => hideSplashScreen(), delayMs);
    return;
  }

  const splash = document.getElementById('splash-screen');
  if (!splash || splash.classList.contains('is-hidden')) return;

  window.clearTimeout(hideTimeout);
  splash.classList.add('is-hidden');
  hideTimeout = window.setTimeout(() => {
    splash.hidden = true;
  }, HIDE_TRANSITION_MS);
}

// Resolves once the splash screen covers the page. Coming back from display: none restarts its animations.
export function showSplashScreen(): Promise<void> {
  const splash = document.getElementById('splash-screen');
  if (!splash) return Promise.resolve();

  window.clearTimeout(hideTimeout);
  splash.classList.remove('is-hidden');
  splash.classList.add('is-reshown');
  splash.hidden = false;

  return new Promise((resolve) => {
    window.setTimeout(resolve, SHOW_TRANSITION_MS);
  });
}
